import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmniGeralRestService } from '../../omni-rest/omni-geral/omni-geral-rest.service';

@Injectable()
export class TipoResidenciaService {

  constructor(private restService: OmniGeralRestService) { }

  getTipoResidencia(): Observable<any> {
    return this.restService.get('tipos-residencia');
  }
}
